<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Edit Node Commands</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>

  <div class="modal-body">
    <form spellcheck="false" autocomplete="off" (ngSubmit)="onSubmit()">
      <mat-form-field style="width: 100%;">
        <input type="text" matInput placeholder="BMC IP" [(ngModel)]="bmCIp" [ngModelOptions]="{standalone: true}" />
      </mat-form-field>
      <br>
      <mat-form-field style="width: 100%;">
        <input type="text" matInput placeholder="MAC Address" [(ngModel)]="mac" [ngModelOptions]="{standalone: true}" />
      </mat-form-field>
      <br>
      <mat-form-field style="width: 100%;">
        <textarea matInput placeholder="Start Command" [(ngModel)]="startCommand" [ngModelOptions]="{standalone: true}"></textarea>
      </mat-form-field>
      <br>
      <mat-form-field style="width: 100%;">
        <textarea matInput placeholder="Stop Command" [(ngModel)]="stopCommand" [ngModelOptions]="{standalone: true}"></textarea>
      </mat-form-field>
      <br>
      <mat-form-field style="width: 100%;">
        <textarea matInput placeholder="Restart Command" [(ngModel)]="restartCommand" [ngModelOptions]="{standalone: true}"></textarea>
      </mat-form-field>
    </form>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary"
            (click)="onSubmit()">
      Submit
    </button>
  </div>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="default"
             zIndex="1"
             color="var(--s-primary-color)"
             type="ball-spin"
             [fullScreen]="false"
             name="addNode"><p class="pleaseWait text-grey">Please wait ...</p></ngx-spinner>
